export const queryKeys = {
  CLIENT_FILTER_INFINITY: 'CLIENT_FILTER_INFINITY',
  CLIENT: 'CLIENT',
  CLIENT_CASHBACK: 'CLIENT_CASHBACK',
  CLIENT_ID_PAYMENT_V2: 'CLIENT_ID_PAYMENT_V2',
  FORCE_ATTACH_CLIENT_CONFIG_ALL: 'FORCE_ATTACH_CLIENT_CONFIG_ALL',
  FORCE_ATTACH_CLIENT: 'FORCE_ATTACH_CLIENT'
};
